export default "__VITE_ASSET__2bbd4404__$_?component__"